var UIBlockConfig = function (blockUIConfig) {
  blockUIConfig.template = function() {
    return '<div class="block-ui-overlay"></div><div spin></div>';
  };
};

app.config(['blockUIConfig', UIBlockConfig]);
app.run(['$state', 'blockUIConfig', function ($state, blockUIConfig) {
  blockUIConfig.requestFilter = function (config) {
    // Skip blocking UI for the specific state 'unit-turn.tasks'
    if ($state.is('unit-turn.tasks')) {
      return false;
    }
    if ($state.is('property.tasks')){
      return false;
    } 
    if ($state.includes('documents')) {
      return false;
    }
    // Skip blocking for share download pages - they have their own loading UI
    if ($state.is('share-document') || $state.is('share-attachment')) {
      return false;
    }
    if (config.url.match(/noblockui/gi)) {
        return false; // ... don't block it.
    }
    if (config.data && config.data.not_load) {
        return false; // ... don't block it.
    }
    return true;
  };
}]);
